<template>
  <div class="flex flex-col h-full">
    <div v-if="category" class="content">
      <div class="category-header" :class="category.slug">
        <div class="col-1 ml-3"></div>
        <h2>{{ category.name }}</h2>
        <div class="col-6 category-background" :class="category.slug"></div>
      </div>
      <div class="profiles flex flex-wrap">
        <div class="col-md-4 col-xl-3 my-3" v-for="article in articlesByCategory" v-bind:key="article.id">
          <player-profile-link :article="article" :show-article-category-icon="false"></player-profile-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import { CategoryArticlesLoaded } from '@/common/guards/categoryArticlesLoaded.guard';
  import { CHANGE_DOC_TITLE } from '@/store/actions/app.actions';
  import PlayerProfileLink from '@/views/Student/PlayerProfileLink';

  export default {
    name: 'index',

    components: {
      PlayerProfileLink
    },

    computed: {
      ...mapGetters(['articles', 'categories', 'category']),
      articlesByCategory: function () {
        const articles = this.articles.filter(b => b.categories.find(x => x.id === this.category.id));

        return _.orderBy(articles, ['last_name', 'first_name'], ['asc', 'asc']);
      }
    },

    created: function () {
      this.$store.dispatch(CHANGE_DOC_TITLE, {title: this.category.name, useBaseTitle: true})
    },

    watch: {
      category: function (newValue) {
        this.$store.dispatch(CHANGE_DOC_TITLE, {title: newValue.name, useBaseTitle: true})
      }
    },

    beforeRouteUpdate (to, from, next) {
      return CategoryArticlesLoaded(to, from, next);
    }
  }
</script>

<style lang="scss" scoped>
  .content {
    padding-top: 236px;

    @media (min-width: config('screens.lg')) {
      padding-top: calc(config('staticHeight.header') + config('staticHeight.categoryCarousel') + config('staticHeight.breadcrumbs'));
    }
  }

  .category-header {
    @apply flex text-white items-center relative mb-3 w-full;
    height: 240px;

    &.craft {
      background: no-repeat url("~@/assets/images/craft-category-header-bg.svg");
    }

    &.build {
      background: no-repeat url("~@/assets/images/build-category-header-bg.svg");
    }

    &.experiment {
      background: no-repeat url("~@/assets/images/experiment-category-header-bg.svg");
    }

    &.eat {
      background: no-repeat url("~@/assets/images/eat-category-header-bg.svg");
    }

    &.celebrate {
      background: no-repeat url("~@/assets/images/celebrate-category-header-bg.svg");
    }

    h2 {
      z-index: 10;
    }

    &.craft {
      @apply bg-c1-b;
    }

    &.build {
      @apply bg-c2-b;
    }

    &.experiment {
      @apply bg-c3-b;
    }

    &.eat {
      @apply bg-c4-b;
    }

    &.celebrate {
      @apply bg-c5-b;
    }
  }
</style>
